



















import Vue from "vue";

import { MaintenanceStatusEnumToLabel, MaintenanceStatusEnum } from "@/model/data/status/MaintenanceStatusEnum";

export default Vue.extend({
    data() {
        return {
            selectedItems: [],
        };
    },
    computed: {
        availableServiceModeStatus() {
            let res = [];
            Object.keys(MaintenanceStatusEnum)
                .filter((k) => typeof MaintenanceStatusEnum[k as any] === "number")
                .forEach((k) => {
                    if (MaintenanceStatusEnum[k] >= 0) res.push({ label: this.$t(MaintenanceStatusEnumToLabel(MaintenanceStatusEnum[k])), value: MaintenanceStatusEnum[k as any] });
                });
            return res;
        },
    },
    watch: {
        selectedItems() {
            this.$emit("input", this.selectedItems);
        },
    },
});
